export const restaurents = [
  {
    "type": "restaurant",
    "info": {
      "resId": 182,
      "name": "McDonald's",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/171/50c3ff296839c4f3f3fc27ec583ba4e6_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/171/50c3ff296839c4f3f3fc27ec583ba4e6_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.2",
        "rating_text": "4.2",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "6,759",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.0",
            "reviewCount": "379",
            "reviewTextSmall": "379 Reviews",
            "subtext": "379 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.0",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.3",
            "reviewCount": "6,380",
            "reviewTextSmall": "6,380 Reviews",
            "subtext": "6,380 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.3",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Janpath, New Delhi",
        "address": "42, Atul Grove Road, Janpath, New Delhi",
        "localityUrl": "ncr/janpath-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/coffee/",
          "name": "Coffee"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "19 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/mcdonalds-janpath-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/mcdonalds-janpath-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.9 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"182\",\"element_type\":\"listing\",\"rank\":1}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "6325+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 586,
      "name": "Nathu's Sweets",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/4/584/bdab27a41125cd45ddf814c7fad470b2_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/4/584/bdab27a41125cd45ddf814c7fad470b2_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.8",
        "rating_text": "3.8",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "3,157",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.7",
            "reviewCount": "348",
            "reviewTextSmall": "348 Reviews",
            "subtext": "348 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.7",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "2,809",
            "reviewTextSmall": "2,809 Reviews",
            "subtext": "2,809 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹700 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Sunder Nagar, New Delhi",
        "address": "2, Main Market, Sunder Nagar, New Delhi",
        "localityUrl": "ncr/sunder-nagar-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mithai/",
          "name": "Mithai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "37 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/nathus-sweets-sunder-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/nathus-sweets-sunder-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"586\",\"element_type\":\"listing\",\"rank\":2}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "1100+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 844,
      "name": "Khan Chacha",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/4/844/a56d7411e731c607628507772aff375a_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/4/844/a56d7411e731c607628507772aff375a_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.2",
        "rating_text": "4.2",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "5,363",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.1",
            "reviewCount": "3,471",
            "reviewTextSmall": "3,471 Reviews",
            "subtext": "3,471 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.1",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.3",
            "reviewCount": "1,892",
            "reviewTextSmall": "1,892 Reviews",
            "subtext": "1,892 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.3",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Khan Market, New Delhi",
        "address": "Shop 50, 1st Floor, Middle Lane, Khan Market, New Delhi",
        "localityUrl": "ncr/restaurants/in/khan-market"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mughlai/",
          "name": "Mughlai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/rolls/",
          "name": "Rolls"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "34 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/khan-chacha-khan-market-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/khan-chacha-khan-market-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"844\",\"element_type\":\"listing\",\"rank\":3}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹125 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2925+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20339576,
      "name": "Haldiram's",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/550/59c4d360f85cb372ad44f588b3625ce6_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/550/59c4d360f85cb372ad44f588b3625ce6_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.8",
        "rating_text": "3.8",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "92",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.5",
            "reviewCount": "3",
            "reviewTextSmall": "3 Reviews",
            "subtext": "3 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.5",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.1",
            "reviewCount": "89",
            "reviewTextSmall": "89 Reviews",
            "subtext": "89 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.1",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹450 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Bikaner House, New Delhi",
        "address": "Bikaner House, Chankya Puri, Pandara Road Market, New Delhi",
        "localityUrl": "ncr/restaurants/in/bikaner-house"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/continental/",
          "name": "Continental"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "25 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/haldirams-pandara-road-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/haldirams-pandara-road-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "392 m",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20339576\",\"element_type\":\"listing\",\"rank\":4}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "975+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 302156,
      "name": "Subway",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/147/8aea16d34892cf7fee812b64c19137bd_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/147/8aea16d34892cf7fee812b64c19137bd_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.9",
        "rating_text": "3.9",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "5,121",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.8",
            "reviewCount": "516",
            "reviewTextSmall": "516 Reviews",
            "subtext": "516 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.8",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "4,605",
            "reviewTextSmall": "4,605 Reviews",
            "subtext": "4,605 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "M 8, Plot 3, M Block, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/health-food/",
          "name": "Healthy Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/sandwich/",
          "name": "Sandwich"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/salad/",
          "name": "Salad"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/wraps/",
          "name": "Wraps"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "27 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/subway-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/subway-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.2 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"302156\",\"element_type\":\"listing\",\"rank\":5}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "3750+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/695598f38d29d0e5d3f8ffe57cfdb94c1613145422.png",
          "aspect_ratio": 2.0625
        },
        "text": "Restaurant partner follows WHO protocol"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19768232,
      "name": "La Pino'z Pizza",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/18619067/5246b64c154fee077ce8cc18724dc3cf_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/18619067/5246b64c154fee077ce8cc18724dc3cf_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.1",
        "rating_text": "4.1",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "5,102",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.2",
            "reviewCount": "501",
            "reviewTextSmall": "501 Reviews",
            "subtext": "501 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.2",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "4,601",
            "reviewTextSmall": "4,601 Reviews",
            "subtext": "4,601 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Lajpat Nagar 2, New Delhi",
        "address": "C-51, Central Market Road, Lajpat Nagar 2, New Delhi",
        "localityUrl": "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/italian/",
          "name": "Italian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pasta/",
          "name": "Pasta"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "37 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/la-pinoz-pizza-lajpat-nagar-2-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/la-pinoz-pizza-lajpat-nagar-2-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "4.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19768232\",\"element_type\":\"listing\",\"rank\":6}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "4275+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18757043,
      "name": "Nazeer Foods",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/3/18757043/d3a1fbc8a36f25d06071f84e3dfd8107_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/3/18757043/d3a1fbc8a36f25d06071f84e3dfd8107_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.5",
        "rating_text": "3.5",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "2,877",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.0",
            "reviewCount": "178",
            "reviewTextSmall": "178 Reviews",
            "subtext": "178 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.0",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "yellow",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "2,699",
            "reviewTextSmall": "2,699 Reviews",
            "subtext": "2,699 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹600 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "M-42, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mughlai/",
          "name": "Mughlai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/biryani/",
          "name": "Biryani"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "32 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/nazeer-foods-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/nazeer-foods-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18757043\",\"element_type\":\"listing\",\"rank\":7}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 15% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "775+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 899,
      "name": "Saravana Bhavan",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/9/899/6812b7d6166430abf0f62016ea8fe548_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/9/899/6812b7d6166430abf0f62016ea8fe548_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.4",
        "rating_text": "4.4",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "15.2K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.5",
            "reviewCount": "3,128",
            "reviewTextSmall": "3,128 Reviews",
            "subtext": "3,128 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.5",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.3",
            "reviewCount": "12.1K",
            "reviewTextSmall": "12.1K Reviews",
            "subtext": "12.1K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.3",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹600 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Janpath, New Delhi",
        "address": "50, Atul Grove Road, Janpath, New Delhi",
        "localityUrl": "ncr/janpath-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY0XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/juices/",
          "name": "Juices"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "30 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/saravana-bhavan-janpath-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/saravana-bhavan-janpath-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.8 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"899\",\"element_type\":\"listing\",\"rank\":8}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "7350+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18268367,
      "name": "Aashirwad Restaurant",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/18268367/1a6d64915ff2482b3777b59fe59102a4_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/7/18268367/1a6d64915ff2482b3777b59fe59102a4_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.8",
        "rating_text": "3.8",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "11.6K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.8",
            "reviewCount": "11.6K",
            "reviewTextSmall": "11.6K Reviews",
            "subtext": "11.6K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.8",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Laxmi Nagar, New Delhi",
        "address": "B-31/125, Gali 4, Mangal Bazar Road, Guru Nanak Pura, Laxmi Nagar, New Delhi",
        "localityUrl": "ncr/laxmi-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "33 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/aashirwad-restaurant-laxmi-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/aashirwad-restaurant-laxmi-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18268367\",\"element_type\":\"listing\",\"rank\":9}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 20% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "Flat ₹125 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "8325+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 8340,
      "name": "Nathu's Pastry Shop",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/0/8340/977b0181445f3a15526ce982a15491bd_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/0/8340/977b0181445f3a15526ce982a15491bd_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.9",
        "rating_text": "3.9",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "2,194",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.7",
            "reviewCount": "257",
            "reviewTextSmall": "257 Reviews",
            "subtext": "257 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.7",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.1",
            "reviewCount": "1,937",
            "reviewTextSmall": "1,937 Reviews",
            "subtext": "1,937 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.1",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Bengali Market, Mandi House, New Delhi",
        "address": "12 & 13, Bengali Market, Mandi House, New Delhi",
        "localityUrl": "ncr/restaurants/in/bengali-market-mandi-house"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/bakery/",
          "name": "Bakery"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "24 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/nathus-pastry-shop-mandi-house-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/nathus-pastry-shop-mandi-house-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.9 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"8340\",\"element_type\":\"listing\",\"rank\":10}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2550+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/695598f38d29d0e5d3f8ffe57cfdb94c1613145422.png",
          "aspect_ratio": 2.0625
        },
        "text": "Restaurant partner follows WHO protocol"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19048234,
      "name": "Punikar's",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/4/19048234/6add780ae9ccdccff67eda6762aa10ff_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/4/19048234/6add780ae9ccdccff67eda6762aa10ff_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.2",
        "rating_text": "4.2",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "1,040",
        "subtext": "REVIEW",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "3",
            "reviewTextSmall": "3 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.2",
            "reviewCount": "1,037",
            "reviewTextSmall": "1,037 Reviews",
            "subtext": "1,037 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.2",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹150 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Pandav Nagar, New Delhi",
        "address": "E-1, Shop 2, Ganesh Nagar, Pandav Nagar Complex, Main Kali Mandir Road, Pandav Nagar, New Delhi",
        "localityUrl": "ncr/pandav-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/maharashtrian/",
          "name": "Maharashtrian"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "41 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/punikars-pandav-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/punikars-pandav-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.1 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19048234\",\"element_type\":\"listing\",\"rank\":11}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "1075+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/695598f38d29d0e5d3f8ffe57cfdb94c1613145422.png",
          "aspect_ratio": 2.0625
        },
        "text": "Restaurant partner follows WHO protocol"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 4847,
      "name": "Pizza Hut",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/246/3f082a046a641c523081cbab51734d9f_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/246/3f082a046a641c523081cbab51734d9f_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.6",
        "rating_text": "3.6",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "6,780",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.4",
            "reviewCount": "267",
            "reviewTextSmall": "267 Reviews",
            "subtext": "267 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.4",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.7",
            "reviewCount": "6,513",
            "reviewTextSmall": "6,513 Reviews",
            "subtext": "6,513 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.7",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹600 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Lajpat Nagar 2, New Delhi",
        "address": "K-95, Lajpat Nagar 2, New Delhi",
        "localityUrl": "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pasta/",
          "name": "Pasta"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "41 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/pizza-hut-1-lajpat-nagar-2-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/pizza-hut-1-lajpat-nagar-2-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"4847\",\"element_type\":\"listing\",\"rank\":12}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2950+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },

  {
    "type": "restaurant",
    "info": {
      "resId": 4057,
      "name": "Bikanervala",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/491/aa50c08ea5ade50a6d1c2d7aca242a1c_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/491/aa50c08ea5ade50a6d1c2d7aca242a1c_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.6",
        "rating_text": "3.6",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "8,138",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.5",
            "reviewCount": "498",
            "reviewTextSmall": "498 Reviews",
            "subtext": "498 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.5",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.7",
            "reviewCount": "7,640",
            "reviewTextSmall": "7,640 Reviews",
            "subtext": "7,640 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.7",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "1st Floor, Rajiv Gandhi Handicraft Bhavan, Baba Kharak Singh Marg, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mithai/",
          "name": "Mithai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "36 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/bikanervala-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/bikanervala-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.5 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"4057\",\"element_type\":\"listing\",\"rank\":1}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "1650+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 300658,
      "name": "Hira Sweets",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/8/300658/10d9c268283384fae4f30ce49f5e404e_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/8/300658/10d9c268283384fae4f30ce49f5e404e_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "6,760",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.9",
            "reviewCount": "513",
            "reviewTextSmall": "513 Reviews",
            "subtext": "513 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.9",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.1",
            "reviewCount": "6,247",
            "reviewTextSmall": "6,247 Reviews",
            "subtext": "6,247 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.1",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "K 19/21, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mithai/",
          "name": "Mithai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "33 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/hira-sweets-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/hira-sweets-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"300658\",\"element_type\":\"listing\",\"rank\":2}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "4250+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 6124,
      "name": "Apni Rasoi",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/4/6124/496abe21e910f0478cc67d992f324d24_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/4/6124/496abe21e910f0478cc67d992f324d24_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.8",
        "rating_text": "3.8",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "8,666",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.8",
            "reviewCount": "350",
            "reviewTextSmall": "350 Reviews",
            "subtext": "350 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.8",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.8",
            "reviewCount": "8,316",
            "reviewTextSmall": "8,316 Reviews",
            "subtext": "8,316 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.8",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹350 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Pandav Nagar, New Delhi",
        "address": "A-2, Ganesh Nagar Complex, Pandav Nagar, New Delhi",
        "localityUrl": "ncr/pandav-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "33 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/apni-rasoi-pandav-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/apni-rasoi-pandav-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.5 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"6124\",\"element_type\":\"listing\",\"rank\":3}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 20% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "Flat ₹150 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "8125+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18895496,
      "name": "The Burger Club",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/17953943/816872e9f1fcc43304e21a0f050f5f21_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/17953943/816872e9f1fcc43304e21a0f050f5f21_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.2",
        "rating_text": "4.2",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "14.7K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.3",
            "reviewCount": "2,400",
            "reviewTextSmall": "2,400 Reviews",
            "subtext": "2,400 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.3",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "12.3K",
            "reviewTextSmall": "12.3K Reviews",
            "subtext": "12.3K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹700 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Lajpat Nagar 2, New Delhi",
        "address": "E-3, 1st Floor, Lajpat Nagar 2, New Delhi ",
        "localityUrl": "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/cafes/",
          "name": "Cafe"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/coffee/",
          "name": "Coffee"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "36 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/the-burger-club-lajpat-nagar-2-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/the-burger-club-lajpat-nagar-2-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "4.9 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18895496\",\"element_type\":\"listing\",\"rank\":4}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 10% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2475+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18219558,
      "name": "Bikkgane Biryani",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/307893/2738bd3dfa84f54d62587a1f5af1c8fe_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/307893/2738bd3dfa84f54d62587a1f5af1c8fe_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.1",
        "rating_text": "4.1",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "16.5K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.1",
            "reviewCount": "2,007",
            "reviewTextSmall": "2,007 Reviews",
            "subtext": "2,007 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.1",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "14.5K",
            "reviewTextSmall": "14.5K Reviews",
            "subtext": "14.5K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "P-2/90, Opposite PVR Rivoli, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/biryani/",
          "name": "Biryani"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDlcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/hyderabadi/",
          "name": "Hyderabadi"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMlwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/andhra/",
          "name": "Andhra"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mughlai/",
          "name": "Mughlai"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "30 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/bikkgane-biryani-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/bikkgane-biryani-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18219558\",\"element_type\":\"listing\",\"rank\":5}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "6500+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18237356,
      "name": "Burger Singh - Big Punjabi Burgers",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/310301/0bb4ccbc6a9fb81b05c4870715419519_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/1/310301/0bb4ccbc6a9fb81b05c4870715419519_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.1",
        "rating_text": "4.1",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "11.4K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.9",
            "reviewCount": "1,539",
            "reviewTextSmall": "1,539 Reviews",
            "subtext": "1,539 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.9",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.2",
            "reviewCount": "9,897",
            "reviewTextSmall": "9,897 Reviews",
            "subtext": "9,897 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.2",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "H-45, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/momos/",
          "name": "Momos"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "30 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/burger-singh-big-punjabi-burgers-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/burger-singh-big-punjabi-burgers-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18237356\",\"element_type\":\"listing\",\"rank\":6}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "3525+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18216915,
      "name": "Biryani Blues",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/301718/15c89d5c951cac68710fdc0e7ff9ef9f_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/301718/15c89d5c951cac68710fdc0e7ff9ef9f_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.1",
        "rating_text": "4.1",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "28.3K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.1",
            "reviewCount": "2,178",
            "reviewTextSmall": "2,178 Reviews",
            "subtext": "2,178 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.1",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.1",
            "reviewCount": "26.1K",
            "reviewTextSmall": "26.1K Reviews",
            "subtext": "26.1K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.1",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "Showroom 9, Scindia House, Connaught Circus, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "Opens in 20 minutes",
        "color": "#e5521f"
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/biryani/",
          "name": "Biryani"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/kebab/",
          "name": "Kebab"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "30 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/biryani-blues-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/biryani-blues-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.1 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18216915\",\"element_type\":\"listing\",\"rank\":7}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹125 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "3925+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19578165,
      "name": "RollsKing",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/300988/f9584388125be2b088f1631054735654_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/300988/f9584388125be2b088f1631054735654_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.7",
        "rating_text": "3.7",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "2,272",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.6",
            "reviewCount": "75",
            "reviewTextSmall": "75 Reviews",
            "subtext": "75 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.6",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.8",
            "reviewCount": "2,197",
            "reviewTextSmall": "2,197 Reviews",
            "subtext": "2,197 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.8",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Defence Colony, New Delhi",
        "address": "Shop 132, Flyover Market, Defence Colony, New Delhi",
        "localityUrl": "ncr/defence-colony-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/rolls/",
          "name": "Rolls"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "34 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/rollsking-defence-colony-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/rollsking-defence-colony-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "4 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19578165\",\"element_type\":\"listing\",\"rank\":8}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹150 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2750+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18365882,
      "name": "Behrouz Biryani",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/2/18363082/4aa2853159bd98bad02a7cd5f2f40be6_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/2/18363082/4aa2853159bd98bad02a7cd5f2f40be6_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "5,782",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "5,782",
            "reviewTextSmall": "5,782 Reviews",
            "subtext": "5,782 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹750 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "Shop 30, Gandhi Market, Minto Road, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/biryani/",
          "name": "Biryani"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/kebab/",
          "name": "Kebab"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDlcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/hyderabadi/",
          "name": "Hyderabadi"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTU3XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/lucknowi/",
          "name": "Lucknowi"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "37 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/behrouz-biryani-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/behrouz-biryani-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18365882\",\"element_type\":\"listing\",\"rank\":9}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 10% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2400+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18726315,
      "name": "Rom's Pizza",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/18606998/aa68c545bbc5c5737b74c3739723bd59_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/18606998/aa68c545bbc5c5737b74c3739723bd59_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "18.3K",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.1",
            "reviewCount": "783",
            "reviewTextSmall": "783 Reviews",
            "subtext": "783 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.1",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "17.6K",
            "reviewTextSmall": "17.6K Reviews",
            "subtext": "17.6K Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹300 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Laxmi Nagar, New Delhi",
        "address": "U 112-B, Laxmi Nagar, New Delhi",
        "localityUrl": "ncr/laxmi-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "40 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/roms-pizza-1-laxmi-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/roms-pizza-1-laxmi-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.1 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18726315\",\"element_type\":\"listing\",\"rank\":10}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 20% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "1300+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 320,
      "name": "Sagar Ratna",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/305/648f23731cccfc0634fcc77b7eb1a9e0_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/305/648f23731cccfc0634fcc77b7eb1a9e0_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.9",
        "rating_text": "3.9",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "5,481",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.7",
            "reviewCount": "736",
            "reviewTextSmall": "736 Reviews",
            "subtext": "736 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.7",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "4,745",
            "reviewTextSmall": "4,745 Reviews",
            "subtext": "4,745 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹600 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "K-15, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "32 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/sagar-ratna-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/sagar-ratna-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"320\",\"element_type\":\"listing\",\"rank\":11}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "1875+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18412878,
      "name": "Faasos - Wraps & Rolls",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/2/18349892/81cab239d11c646e76cc35b01b25c180_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/2/18349892/81cab239d11c646e76cc35b01b25c180_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "8,889",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "8,889",
            "reviewTextSmall": "8,889 Reviews",
            "subtext": "8,889 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹450 for two"
      },
      "cfo": {
        "text": "₹100 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "Shop 30, Gandhi Market, Minto Road, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/rolls/",
          "name": "Rolls"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/wraps/",
          "name": "Wraps"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹100 for one"
      }
    },
    "order": {
      "deliveryTime": "27 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/faasos-wraps-rolls-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/faasos-wraps-rolls-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18412878\",\"element_type\":\"listing\",\"rank\":12}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹125 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2525+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },

  {
    "type": "restaurant",
    "info": {
      "resId": 18400755,
      "name": "Theobroma",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/18384116/89bf140d9f4e483a00202e0668a35ef7_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/18384116/89bf140d9f4e483a00202e0668a35ef7_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.4",
        "rating_text": "4.4",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "9,962",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.4",
            "reviewCount": "922",
            "reviewTextSmall": "922 Reviews",
            "subtext": "922 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.4",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.3",
            "reviewCount": "9,040",
            "reviewTextSmall": "9,040 Reviews",
            "subtext": "9,040 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.3",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹300 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "D-28, Ground Floor, Mezzanine, Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/bakery/",
          "name": "Bakery"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "20 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/theobroma-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/theobroma-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.5 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18400755\",\"element_type\":\"listing\",\"rank\":1}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "5525+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20264514,
      "name": "BTW",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/1995/66c3391a905f35b30920de207cbe688e_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/1995/66c3391a905f35b30920de207cbe688e_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.6",
        "rating_text": "3.6",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "161",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.2",
            "reviewCount": "10",
            "reviewTextSmall": "10 Reviews",
            "subtext": "10 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.2",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "151",
            "reviewTextSmall": "151 Reviews",
            "subtext": "151 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹450 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Laxmi Nagar, New Delhi",
        "address": "Shop 4 & 5, 113 Veer Savarkar Block, Vikas Marg, Near Aggarwal Chambers, Laxmi Nagar, New Delhi",
        "localityUrl": "ncr/laxmi-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "40 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/btw-laxmi-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/btw-laxmi-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.9 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20264514\",\"element_type\":\"listing\",\"rank\":2}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "875+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20100119,
      "name": "Madras Cafe",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/9/20100119/62ee86aa96e2e7a43eb120caa2c7eedf_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/9/20100119/62ee86aa96e2e7a43eb120caa2c7eedf_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.9",
        "rating_text": "3.9",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "280",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "280",
            "reviewTextSmall": "280 Reviews",
            "subtext": "280 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹250 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Chander Nagar, New Delhi",
        "address": "6/2, Chawla Park, Near Sai Mandir, Chander Nagar, New Delhi",
        "localityUrl": "ncr/chander-nagar-delhi-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "48 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/madras-cafe-chander-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/madras-cafe-chander-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "6.7 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20100119\",\"element_type\":\"listing\",\"rank\":3}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "775+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20450721,
      "name": "WOW! Momo",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/18082196/cc7cfcafbaa312b8e003ab60181246b0_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/6/18082196/cc7cfcafbaa312b8e003ab60181246b0_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.6",
        "rating_text": "3.6",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "20",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.2",
            "reviewCount": "1",
            "reviewTextSmall": "1 Reviews",
            "subtext": "1 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.2",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "19",
            "reviewTextSmall": "19 Reviews",
            "subtext": "19 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹400 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Barakhamba Road, New Delhi",
        "address": "Plot 1, Shop 37, Bengali Market, Todermal Road Area, Barakhamba Road, New Delhi",
        "localityUrl": "ncr/barakhamba-road-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/momos/",
          "name": "Momos"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTNcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/tibetan/",
          "name": "Tibetan"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "27 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/wow-momo-barakhamba-road-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/wow-momo-barakhamba-road-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "1.9 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20450721\",\"element_type\":\"listing\",\"rank\":4}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "225+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19761128,
      "name": "Kwality Wall’s Frozen Dessert and Ice Cream Shop",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/19144765/ae4bee1430d091eedd5c853b4bd91689_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/19144765/ae4bee1430d091eedd5c853b4bd91689_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.6",
        "rating_text": "4.6",
        "rating_subtitle": "Excellent",
        "rating_color": "3F7E00",
        "votes": "231",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.6",
            "reviewCount": "231",
            "reviewTextSmall": "231 Reviews",
            "subtext": "231 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.6",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "800"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹200 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Jor Bagh, New Delhi",
        "address": "Shop 8, B.K Dutt Colony, Ali Gang Karbala, Jor Bagh, New Delhi",
        "localityUrl": "ncr/jor-bagh-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjMzXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/ice-cream/",
          "name": "Ice Cream"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "28 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/kwality-walls-frozen-dessert-and-ice-cream-shop-jor-bagh-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/kwality-walls-frozen-dessert-and-ice-cream-shop-jor-bagh-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "3.6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19761128\",\"element_type\":\"listing\",\"rank\":5}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "50+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20085616,
      "name": "Bakingo",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/18416840/297e6c82fbf1b14832189765dd0bdcc5_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/18416840/297e6c82fbf1b14832189765dd0bdcc5_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.2",
        "rating_text": "4.2",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "1,233",
        "subtext": "REVIEW",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.2",
            "reviewCount": "1,233",
            "reviewTextSmall": "1,233 Reviews",
            "subtext": "1,233 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.2",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹300 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "New Friends Colony, New Delhi",
        "address": "Shop 1, Lower Ground Floor, Bharat Nagar, New Friends Colony, New Delhi",
        "localityUrl": "ncr/new-friends-colony-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/bakery/",
          "name": "Bakery"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "36 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/bakingo-new-friends-colony-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/bakingo-new-friends-colony-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "6.6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20085616\",\"element_type\":\"listing\",\"rank\":6}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹100 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "3150+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18658316,
      "name": "Biryani By Kilo",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/312995/46e83cf1a459cd422c0aaf2945e7b3c5_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/5/312995/46e83cf1a459cd422c0aaf2945e7b3c5_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.3",
        "rating_text": "4.3",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "8,016",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.4",
            "reviewCount": "1,529",
            "reviewTextSmall": "1,529 Reviews",
            "subtext": "1,529 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.4",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.2",
            "reviewCount": "6,487",
            "reviewTextSmall": "6,487 Reviews",
            "subtext": "6,487 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.2",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹800 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "N 79, 1st Floor, Pratap Building, N Block, Connaught Circle, Near Connaught Place, New Delhi",
        "localityUrl": "ncr/connaught-place-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/biryani/",
          "name": "Biryani"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDlcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/hyderabadi/",
          "name": "Hyderabadi"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/kebab/",
          "name": "Kebab"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mughlai/",
          "name": "Mughlai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "90 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/biryani-by-kilo-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/biryani-by-kilo-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.2 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18658316\",\"element_type\":\"listing\",\"rank\":7}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹125 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2650+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 18237315,
      "name": "Chaayos Chai+Snacks=Relax",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/9/300749/68269a74598b089b88fcb9ef097b11a1_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/9/300749/68269a74598b089b88fcb9ef097b11a1_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.1",
        "rating_text": "4.1",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "9,333",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "4.1",
            "reviewCount": "1,420",
            "reviewTextSmall": "1,420 Reviews",
            "subtext": "1,420 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "4.1",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "700"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "7,913",
            "reviewTextSmall": "7,913 Reviews",
            "subtext": "7,913 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹300 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Connaught Place, New Delhi",
        "address": "F-14/15, 1st Floor, Mezzanine, F Block, Inner Circle, Connaught Place, New Delhi",
        "localityUrl": ""
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTYzXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/tea/",
          "name": "Tea"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/sandwich/",
          "name": "Sandwich"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "29 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/chaayos-chai-snacks-relax-connaught-place-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/chaayos-chai-snacks-relax-connaught-place-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "2.2 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"18237315\",\"element_type\":\"listing\",\"rank\":8}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "4125+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19631395,
      "name": "Wendy's",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/312423/7a8d7e619b4825883795f8f873a99aa7_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/3/312423/7a8d7e619b4825883795f8f873a99aa7_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "1,466",
        "subtext": "REVIEW",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "1,466",
            "reviewTextSmall": "1,466 Reviews",
            "subtext": "1,466 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹350 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Defence Colony, New Delhi",
        "address": "Plot 59 B, 2nd Floor, Kotla Mubarak Pur, Defence Colony, New Delhi",
        "localityUrl": "ncr/defence-colony-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/american/",
          "name": "American"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "35 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/wendys-defence-colony-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/wendys-defence-colony-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "4.6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19631395\",\"element_type\":\"listing\",\"rank\":9}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Pro extra 10% OFF",
        "color": {
          "tint": "600",
          "type": "pink"
        }
      },
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "2650+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19086956,
      "name": "Chicago Pizza",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/305120/3be42918076d4cb32d5e5a272feda72d_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/0/305120/3be42918076d4cb32d5e5a272feda72d_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.5",
        "rating_text": "3.5",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "1,488",
        "subtext": "REVIEW",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.4",
            "reviewCount": "93",
            "reviewTextSmall": "93 Reviews",
            "subtext": "93 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.4",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.6",
            "reviewCount": "1,395",
            "reviewTextSmall": "1,395 Reviews",
            "subtext": "1,395 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.6",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹600 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Lajpat Nagar 2, New Delhi",
        "address": "C 7, Ground Floor, Roxy Chowk, Lajpat Nagar 2, New Delhi",
        "localityUrl": "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pasta/",
          "name": "Pasta"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "37 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/chicago-pizza-lajpat-nagar-2-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/chicago-pizza-lajpat-nagar-2-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "4.8 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19086956\",\"element_type\":\"listing\",\"rank\":10}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "Flat ₹150 OFF",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "675+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 20387666,
      "name": "Gulab Wala",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/6/20387666/d29bd2d8965d8f778cba2c0f4eacd0d1_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/6/20387666/d29bd2d8965d8f778cba2c0f4eacd0d1_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "4.0",
        "rating_text": "4.0",
        "rating_subtitle": "Very Good",
        "rating_color": "5BA829",
        "votes": "5",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "",
            "reviewCount": "0",
            "reviewTextSmall": "0 Reviews",
            "subtext": "Does not offer Dining",
            "color": "",
            "ratingV2": "-",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "grey",
              "tint": "500"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "4.0",
            "reviewCount": "5",
            "reviewTextSmall": "5 Reviews",
            "subtext": "5 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "4.0",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹300 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Safdarjung, New Delhi",
        "address": "AB-9A, Second Floor, Safdurjung Enclave Market, Safdarjung, New Delhi",
        "localityUrl": "ncr/safdarjung-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/mithai/",
          "name": "Mithai"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/north-indian/",
          "name": "North Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/street-food/",
          "name": "Street Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/chinese/",
          "name": "Chinese"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/south-indian/",
          "name": "South Indian"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/desserts/",
          "name": "Desserts"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/beverages/",
          "name": "Beverages"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "40 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/gulab-wala-safdarjung-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/gulab-wala-safdarjung-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "6 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"20387666\",\"element_type\":\"listing\",\"rank\":11}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "50+ orders placed from here recently"
      }
    ]
  },
  {
    "type": "restaurant",
    "info": {
      "resId": 19868535,
      "name": "Rominus Pizza And Burger",
      "image": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/19295908/feeae57472a4f311f8cbb52f3c0d09ed_o2_featured_v2.jpg"
      },
      "o2FeaturedImage": {
        "url": "https://b.zmtcdn.com/data/pictures/chains/8/19295908/feeae57472a4f311f8cbb52f3c0d09ed_o2_featured_v2.jpg"
      },
      "rating": {
        "has_fake_reviews": 0,
        "aggregate_rating": "3.8",
        "rating_text": "3.8",
        "rating_subtitle": "Good",
        "rating_color": "9ACD32",
        "votes": "2,396",
        "subtext": "REVIEWS",
        "is_new": false
      },
      "ratingNew": {
        "newlyOpenedObj": null,
        "suspiciousReviewObj": null,
        "ratings": {
          "DINING": {
            "rating_type": "DINING",
            "rating": "3.7",
            "reviewCount": "36",
            "reviewTextSmall": "36 Reviews",
            "subtext": "36 Dining Reviews",
            "color": "#1C1C1C",
            "ratingV2": "3.7",
            "subtitle": "DINING",
            "sideSubTitle": "Dining Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            }
          },
          "DELIVERY": {
            "rating_type": "DELIVERY",
            "rating": "3.9",
            "reviewCount": "2,360",
            "reviewTextSmall": "2,360 Reviews",
            "subtext": "2,360 Delivery Reviews",
            "color": "#E23744",
            "ratingV2": "3.9",
            "subtitle": "DELIVERY",
            "sideSubTitle": "Delivery Reviews",
            "bgColorV2": {
              "type": "green",
              "tint": "600"
            },
            "newOnDelivery": false
          }
        }
      },
      "cft": {
        "text": "₹500 for two"
      },
      "cfo": {
        "text": "₹150 for one"
      },
      "locality": {
        "name": "Laxmi Nagar, New Delhi",
        "address": "U-110, Vikash Marg, Laxmi Nagar, New Delhi",
        "localityUrl": "ncr/laxmi-nagar-delhi-restaurants"
      },
      "timing": {
        "text": "",
        "color": ""
      },
      "cuisine": [
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pizza/",
          "name": "Pizza"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          "url": "https://www.zomato.com/ncr/restaurants/fast-food/",
          "name": "Fast Food"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          "url": "https://www.zomato.com/ncr/restaurants/burger/",
          "name": "Burger"
        },
        {
          "deeplink": "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
          "url": "https://www.zomato.com/ncr/restaurants/pasta/",
          "name": "Pasta"
        }
      ],
      "should_ban_ugc": false,
      "costText": {
        "text": "₹150 for one"
      }
    },
    "order": {
      "deliveryTime": "34 min",
      "isServiceable": true,
      "hasOnlineOrdering": true,
      "actionInfo": {
        "text": "Order Now",
        "clickUrl": "/ncr/rominus-pizza-and-burger-laxmi-nagar-new-delhi/order"
      }
    },
    "gold": [],
    "takeaway": [],
    "cardAction": {
      "text": "",
      "clickUrl": "/ncr/rominus-pizza-and-burger-laxmi-nagar-new-delhi/order",
      "clickActionDeeplink": ""
    },
    "distance": "5.1 km",
    "isPromoted": false,
    "promotedText": "",
    "trackingData": [
      {
        "table_name": "zsearch_events_log",
        "payload": "{\"search_id\":\"60b85be5-7ac1-4f14-86ff-a8abfe08454f\",\"location_type\":\"delivery_cell\",\"location_id\":\"4110909989034393600\",\"page_type\":\"delivery\",\"app_type\":\"new_web_consumer\",\"section\":\"restaurants\",\"entity_type\":\"restaurant\",\"entity_id\":\"19868535\",\"element_type\":\"listing\",\"rank\":12}",
        "event_names": {
          "tap": "{\"action\":\"tap\"}",
          "impression": "{\"action\":\"impression\"}"
        }
      }
    ],
    "allCTA": [],
    "promoOffer": "",
    "checkBulkOffers": true,
    "bulkOffers": [
      {
        "text": "50% OFF up to 100",
        "color": {
          "tint": "500",
          "type": "blue"
        }
      }
    ],
    "isDisabled": false,
    "bottomContainers": [
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        "text": "4325+ orders placed from here recently"
      },
      {
        "image": {
          "url": "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          "aspect_ratio": 2.66666666667
        },
        "text": "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  }
]
